<template>
	<div class="hres83e-calendar-year calendar-box-year calendar-bg-white">
		<div class="calendar-text-center" style="font-size: 1.4em;">
			<i class="fa fa-caret-left fa-lg" aria-hidden="true" style="padding-right: 11px;" v-on:click="setSelectYear(-1)"></i>
	      <div class="dropdown-year">
	      	<hrms-dropdown-year v-model="selectionYear" :minYear="1980" :maxYear="2100" nowLang="en" />
	      </div>
			<i class="fa fa-caret-right fa-lg" aria-hidden="true" style="padding-left: 11px;" v-on:click="setSelectYear(1)"></i>
		</div>
	</div>
</template>

<script>
export default {
  name: 'hres83e-year',
  props: [ 'selectingYear', 'setSelectYear' ],
  data () {
    return {
      selectionYear: this.selectingYear
    }
  },
  watch: {
    selectingYear () {
      this.selectionYear = this.selectingYear
    },
    selectionYear () {
      this.setSelectYear(this.selectionYear - this.selectingYear)
    }
  }
}
</script>

<style lang="scss">
	.hres83e-calendar-year {
	  &.calendar-box-year {
	    font-size: 1.2em;
	    margin-top: 5px;
	    cursor:pointer;
	    .arrow {
	      display: inline-block;
	    }
	    .dropdown-year {
	      display: inline-block;
	      position: relative;
	      top: 9px;
	      .dropdown-nm {
	        background: none;
	        border: none;
	        select {
	          font-size: 23px;
	          font-weight: bold;
	          &::-ms-expand {
	            display: none;
	          }
	        }
	      }
	    }
	  }
	}
</style>


// WEBPACK FOOTER //
// year.vue?071d3b25